import Analytics from '@/components/analytics/Analytics'
import Feed from '@/components/analytics/Feed'

import Calendar from '@/components/calendar/Calendar'

import LearningTools from '@/components/learningtools/LearningTools'

import MyFolders from '@/components/folders/MyFolders'

import BookView from '@/components/library/bookview/BookView'
import SummaryView from '@/components/library/bookview/SummaryView'

import Groups from '@/components/groups/Groups'
import GroupDashboard from '@/components/groups/GroupDashboard'
import LearningPathFullscreen from '@/components/groups/LearningPathFullscreen'

import Library from '@/components/library/Library'
import BookResources from '@/components/library/BookResources'

import ResourceView from '@/components/resource/ResourceView'
import CreateIssue from '@/components/issue/CreateIssue'

import Welcome from '@/components/Welcome'
import NotFound from '@/components/404'
import Logout from '@/components/Logout'

const _ = require('lodash');

const defaultRoutes = [
  {
    path: '/feed',
    name: 'Feed',
    component: Feed
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics
  },
  {
    path: '/folders/:id',
    name: 'MyFolders',
    component: MyFolders
  },
  {
    path: '/learning-tools',
    name: 'LearningTools',
    component: LearningTools
  },
  {
    path: '/groups',
    name: 'Groups',
    component: Groups
  },
  {
    path: '/group/:id',
    name: 'GroupDashboard',
    component: GroupDashboard
  },
  {
    path: '/lp/:id',
    name: 'LearningPathFullscreen',
    component: LearningPathFullscreen
  },
  {
    path: '/library',
    name: 'Library',
    component: Library
  },
  {
    path: '/book-resources/:id',
    name: 'BookResources',
    component: BookResources
  },
  {
    path: '/book/:id/resources',
    name: 'ResourcesPerBook',
    component: BookResources
  },
  {
    path: '/resource/:id',
    name: 'ResourceView',
    component: ResourceView
  },
  {
    path: '/book/:id/:currentPage',
    name: 'BookView',
    component: BookView
  },
  {
    path: '/book/:bookId/pageRange/:from/:to/summary',
    name: 'SummaryView',
    component: SummaryView
  },
  {
    path: '/book/:id',
    name: 'BookViewWithOutPage',
    component: BookView
  },
  {
    path: '/issue',
    name: 'CreateIssue',
    component: CreateIssue
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    disableAuth: true
  },
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
    disableAuth: true
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    disableAuth: true
  }
];

const parentRoutes = [
  {
    path: '/feed',
    name: 'Feed',
    component: Feed
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    disableAuth: true
  },
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
    disableAuth: true
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    disableAuth: true
  }
];

export default {
    defaultRoutes,
    parentRoutes
};